export const downloadFile = (data: BlobPart, filename: string): void => {
  const url = window.URL.createObjectURL(new Blob([data], { type: 'application/octet-stream' }));
  const link = document.createElement('a');

  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  // Give the browser time to start the download before the object URL is released.
  setTimeout(() => window.URL.revokeObjectURL(url), 200);
};
